import React, { useEffect, useState } from "react";
import ContentHeader from "../../components/ContentHeader/ContentHeader";
import { requestGradeByIdentifier } from "../../service/api/RequestService";
import CompanyFoundDetails from "./CompanyFoundDetails";
import { CompanyNotFound } from "./CompanyNotFound";
import { InputWithFlag } from "../../components/InputWithFlag/InputWithFlag";
import './Request.scss';
import { getCountries, getCountryData } from "../../service/api/CountriesSevice";
import { useLocation } from "react-router-dom";
import Spinner from "../../components/Spinner/Spinner";

export const Request = () => {

    const location = useLocation();


    const [companyFound, setCompanyFound] = useState(null);
    const [companyLoaded, setCompanyLoaded] = useState(false);
    const [loading, setLoading] = useState(false);
    const [flagSelected, setFlagSelected] = useState(location.state?.countryCode || "ES");
    const [companyInfoSearch, setCompanyInfoSearch] = useState(location.state?.identification || "");
    const [errors, setErrors] = useState({});
    const [countries, setCountries] = useState([]);
    const [countryData, setCountryData] = useState({
        countryCode: 'ES',
        countryCommonLabel: 'España',
        minLength: 8,
        maxLength: 8
    });

    const validateIdentification = (value) => {
        if (value.length < countryData.minLength || value.length > countryData.maxLength) {
            setErrors({ companyInfoSearch: 'Formato incorrecto' });
        } else {
            setErrors({ companyInfoSearch: null })
        }
    }

    const searchCompany = (e) => {
        e.preventDefault()
        setLoading(true)
        setCompanyFound([]);
        requestGradeByIdentifier(companyInfoSearch, flagSelected).then(data => {
            if (data.debtor && data.debtor.countryCode == null) {
                data.debtor.countryCode = flagSelected;
            }
            setLoading(false)
            setCompanyFound(data)
            setCompanyLoaded(true);
        });
    }

    const handleChangeInput = event => {
        const value = event.target.value;
        validateIdentification(value);
        setCompanyInfoSearch(value);
    }

    useEffect(() => {
        getCountries().then(data => setCountries(data));
    }, []);

    useEffect(() => {
        getCountryData(flagSelected).then(data => {
            setCountryData(data)
        });
    }, [flagSelected]);

    const handleClearClick = () => {
        setCompanyInfoSearch("")
    };

    return (
        <div className="request">
            <ContentHeader titulo="Nueva solicitud" />
            <div className="container">
                <div>
                    <div className="request-container container ps-1">
                        <div className="row">
                            <div className="col-xs-12 col-md-7 request-input">
                                <div className="label text-start">
                                    <p className="input-over-text-bold mb-4">Para comenzar introduce los datos de la empresa, nacional o internacional,
                                        sobre la que quieres consultar el Grade.
                                    </p>
                                    <p className="input-over-text">Puedes buscar tanto por nombre como por número de identificación,
                                        y cambiar el país de origen con el desplegable que encontrarás pulsando en la flecha.
                                    </p>
                                </div>
                                <InputWithFlag
                                    companyInfoSearch={companyInfoSearch}
                                    handleChangeInput={handleChangeInput}
                                    searchCompany={searchCompany}
                                    flagSelected={flagSelected}
                                    setFlagSelected={setFlagSelected}
                                    errors={errors}
                                    countries={countries}
                                    handleClearClick={handleClearClick}

                                />
                            </div>

                        </div>
                    </div>
                </div>
            </div>
            <div className="container request-spinner">
                {loading ? <> <div className="spinner-container"><Spinner /> <h3 className="spinner-text">Buscando</h3></div> </> : <div>
                    <div className="row">
                        <div className="col-12">
                            {companyLoaded ? companyFound && companyFound.length > 0 ? <CompanyFoundDetails companies={companyFound} /> : <CompanyNotFound companyIdentifier={companyInfoSearch} /> : null}
                        </div>
                    </div>
                </div>}
            </div>
        </div>
    )
}